import {API_SERVERLESS, postFetch} from '../../../commonApi';

export function apiSectionSave(jsonData: {name: string}): Promise<any> {
    return postFetch(`${API_SERVERLESS}/acarea/createcategory`, true, jsonData).then((jsonResponse: any) => {
        if (jsonResponse) {
            return jsonResponse;
        }
    });
}
